import { Box, Button, Flex, Icon, Stack, Text } from '@chakra-ui/react';
import { Message } from 'api/types';
import { isEmpty } from 'lodash';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IoDocumentAttachOutline } from 'react-icons/io5';
import { MdOutlineTranslate } from 'react-icons/md';

import { dateTimeTransformer } from '../../helpers/dateTransformer';
import { getDarkStatusColor } from '../../helpers/getColourSchemeBasedOnStatus';
export const ConversationBubble = (props: {
  messageObject: Message;
  statusCodes?: { [x: number]: string };
  currentStatus?: number;
  setFile?: () => void;
}) => {
  const { messageObject, statusCodes, setFile, currentStatus = 999, ...rest } = props;
  const { t } = useTranslation();
  const file = messageObject?.document?.file || {};
  const messageFromOps = Boolean(messageObject?.user_id);
  const hasTranslatedMessage = !!messageObject?.translated_text;
  const [showTranslatedMessage, setShowTranslatedMessage] = useState(true);
  return (
    <Stack spacing={2}>
      <Stack textAlign={'left'} sx={messageFromOps ? { marginLeft: 2 } : { marginRight: 2 }} mb={-2}>
        <Text color="muted" fontSize="12" ml={3}>
          {messageObject?.author} {' - '}
          {dateTimeTransformer(messageObject?.created_at)}
        </Text>
      </Stack>

      <Stack
        spacing={6}
        h="100%"
        rounded="2xl"
        shadow="sm"
        py={{ base: '4', md: '4' }}
        px={{ base: '4', md: '4' }}
        bg={
          messageFromOps
            ? 'gray.500'
            : getDarkStatusColor(statusCodes && Object.hasOwn(statusCodes, currentStatus) ? statusCodes[currentStatus] : 'unknown')
        }
        color={'white'}
        {...rest}
      >
        <Text fontSize="sm" whiteSpace={'pre-wrap'}>
          {showTranslatedMessage && hasTranslatedMessage ? (
            messageObject?.translated_text.split('<br />').map((line) => (
              <Flex key={line} direction={'column'} justifyContent={'space-between'} mb={-3}>
                <Box>{line}</Box>
                <Flex my={-2.5} justifyContent="flex-end">
                  <Flex mr={1} alignItems={'center'} color={'white'}>
                    <MdOutlineTranslate />
                    <Text ml={1} fontSize={'11'}>
                      {t('service_record:status.clarification.conversation.message_translated')}
                    </Text>
                  </Flex>

                  <Button
                    variant="solid"
                    onClick={() => {
                      setShowTranslatedMessage(!showTranslatedMessage);
                    }}
                    colorScheme="white"
                  >
                    <Text decoration={'underline'} fontSize={'12'}>
                      {' '}
                      {t('service_record:status.clarification.conversation.show_original_message')}
                    </Text>
                  </Button>
                </Flex>
              </Flex>
            ))
          ) : (
            <Flex direction={'column'} justifyContent={'space-between'} mb={hasTranslatedMessage ? '-3' : 'inherit'}>
              <Box>{messageObject?.text}</Box>
              {hasTranslatedMessage && (
                <Flex my={-2.5} justifyContent="flex-end">
                  <Flex mr={1} alignItems={'center'} color={'white'}>
                    <MdOutlineTranslate />
                    <Text ml={1} fontSize={'11'}>
                      {t('service_record:status.clarification.conversation.message_translated')}
                    </Text>
                  </Flex>

                  <Button
                    variant="solid"
                    colorScheme="white"
                    onClick={() => {
                      setShowTranslatedMessage(!showTranslatedMessage);
                    }}
                  >
                    <Text decoration={'underline'} fontSize={'12'}>
                      {' '}
                      {t('service_record:status.clarification.conversation.show_translated_message')}
                    </Text>
                  </Button>
                </Flex>
              )}
            </Flex>
          )}

          {!isEmpty(file) && (
            <Box onClick={setFile} cursor="pointer">
              <Icon as={IoDocumentAttachOutline} boxSize="4" />
              {/*@ts-ignore*/}
              {file?.original_name}
            </Box>
          )}
        </Text>
      </Stack>
    </Stack>
  );
};
